module.exports = __webpack_public_path__ + "static/media/Secret Garden.8e0954f2.jpg";